<template>
  <div class="min-h-screen layout-bg">
    <navbar />
    <router-view />
  </div>
</template>
<script>
import Navbar from '@/components/layout/shared/navbar';

export default {
  name: 'workshop',
  metaInfo() {
    return {
      title: this.$i18n.t('Welcome to repair workshop'),
      titleTemplate: `%s - ${this.$store.state.settings.name}`,
    };
  },
  components: { Navbar },
};
</script>
